/**
 * This enum is used to define the model language used by the chatbot.
 *
 * @author Mc Ayrton Aragon
 */
export enum OpenAIChatbotLanguageSupportEnum {
  IT = 'IT',
  EN = 'EN'
}
